/*
 * Calculadora de frete (EasyCoding) — revisada em 22/10/2026
 *
 * A API de frete da Shopify calcula sobre o carrinho, não sobre um produto solto.
 * Por isso, quando o carrinho está vazio, é preciso colocar o item lá por um instante.
 * O código antigo fazia isso de um jeito que causava dois problemas:
 *
 *   1. a gaveta do carrinho abria na frente do cliente a cada clique em "Calcular";
 *   2. o item ficava no carrinho por 10 segundos fixos. Quem fosse ao checkout
 *      nesse intervalo levava um produto que não escolheu.
 *
 * Agora: a gaveta fica segurada fechada durante o cálculo, o item sai assim que o
 * frete responde (não mais 10 segundos fixos), e antes de remover conferimos se o
 * carrinho ainda tem só aquele item — se o cliente mexeu no carrinho, não encostamos.
 */
jQuery(function ($) {

    Shopify.Cart.ShippingCalculator.show( {
        submitButton: "Calcular",
        submitButtonDisabled: "Calculando...",
        moneyFormat: moneyformat
    });

    /* ----------------------------------------------------------------
     * Segura a gaveta do carrinho fechada enquanto o cálculo acontece.
     * O app do carrinho abre a gaveta marcando uma classe no <html>;
     * aqui tiramos essa marca assim que ela aparece, antes de ser desenhada.
     * ---------------------------------------------------------------- */
    var ABERTO = /(^|\s)(essential-cart__open|cart-drawer--open|js-drawer-open|drawer--open)(\s|$)/;
    var observadorGaveta = null;
    var ID_ESTILO = 'frete-ocultar-gaveta';

    // Esconde a gaveta por um instante, só para não piscar na tela enquanto
    // ela é fechada. Não mexemos nas classes do app: fazer isso desencontra o
    // estado interno dele e a gaveta para de abrir nas próximas vezes.
    function ocultarGaveta(ocultar) {
        var el = document.getElementById(ID_ESTILO);
        if (ocultar) {
            if (el) return;
            el = document.createElement('style');
            el.id = ID_ESTILO;
            el.textContent =
                '#essential-cart-drawer-portal,#cart-drawer,.essential-cart-drawer-container' +
                '{visibility:hidden!important;opacity:0!important;pointer-events:none!important}';
            document.head.appendChild(el);
        } else if (el) {
            el.parentNode.removeChild(el);
        }
    }

    // Fecha pelo caminho do próprio app (a mesma tecla que o cliente usaria),
    // para que ele registre o fechamento e continue funcionando normalmente.
    function fecharPeloApp() {
        document.dispatchEvent(new KeyboardEvent('keydown', {
            key: 'Escape', code: 'Escape', keyCode: 27, which: 27, bubbles: true
        }));
    }

    function segurarGaveta(segurar) {
        if (segurar) {
            if (observadorGaveta) return;
            ocultarGaveta(true);
            observadorGaveta = new MutationObserver(function () {
                if (ABERTO.test(document.documentElement.className)) fecharPeloApp();
            });
            observadorGaveta.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        } else if (observadorGaveta) {
            observadorGaveta.disconnect();
            observadorGaveta = null;
            // Se ainda estiver aberta na hora de soltar, fecha uma última vez
            // antes de voltar a mostrar, senão ela aparece de repente.
            if (ABERTO.test(document.documentElement.className)) {
                fecharPeloApp();
                setTimeout(function () { ocultarGaveta(false); }, 600);
            } else {
                ocultarGaveta(false);
            }
        }
    }

    // Se o cliente pedir o carrinho no meio do cálculo, soltamos na hora —
    // segurar a gaveta vale só contra a abertura automática, nunca contra ele.
    $(document).on('click', '[href*="/cart"], [data-cart-toggle], [class*="cart-toggle"], [class*="cart-icon"], [aria-label*="arrinho"]', function () {
        segurarGaveta(false);
    });

    /* ----------------------------------------------------------------
     * Avisa quando o resultado do frete apareceu na tela (ou desistiu).
     * ---------------------------------------------------------------- */
    function aoTerminarCalculo(callback) {
        var alvo = document.querySelector('#wrapper-response');
        var jaChamou = false;
        var obs = null;
        var prazo;

        function fim() {
            if (jaChamou) return;
            jaChamou = true;
            clearTimeout(prazo);
            if (obs) obs.disconnect();
            callback();
        }

        if (alvo) {
            obs = new MutationObserver(function () {
                if (alvo.innerHTML.trim() !== '') fim();
            });
            obs.observe(alvo, { childList: true, subtree: true });
        }
        prazo = setTimeout(fim, 12000); // rede de segurança, caso nada responda
        return fim;
    }

    /* ----------------------------------------------------------------
     * Tira do carrinho o item que só entrou para calcular o frete.
     * Só remove se o carrinho ainda estiver exatamente como deixamos.
     * ---------------------------------------------------------------- */
    function desfazerItemDoCalculo(variantvalue, pronto) {
        jQuery.getJSON('/cart.js', function (cart) {
            var sozinhoComoDeixamos =
                cart.items.length === 1 &&
                String(cart.items[0].variant_id) === String(variantvalue) &&
                cart.items[0].quantity === 1;

            if (sozinhoComoDeixamos) {
                Shopify.removeItem(variantvalue, function () { pronto(); });
            } else {
                // O cliente mexeu no carrinho nesse meio tempo. Não encostamos.
                pronto();
            }
        }).fail(pronto);
    }

    var carregaFrete = function (cep, aoFalhar) {
        if ($("#address_zip").val().length != 9) {
            alert("Digite um cep válido");
            if (aoFalhar) aoFalhar();
            return;
        }

        $(".get-rates-custom").addClass("loading");
        $("#shipping-calculator2 .loading").addClass("load");
        $(".get-rates-custom").attr('value', 'Calculando...');

        $.getJSON("//viacep.com.br/ws/" + cep + "/json/?callback=?", function (dados) {
            if (!("erro" in dados)) {
                if (!$("#shipping-calculator2.shiping-loaded")[0]) {
                    $("#shipping-calculator2").addClass("shiping-loaded");
                }
                var state;
                var uf = dados.uf.toUpperCase();
                switch (uf) {
                    case "AC" :	state = "Acre";					break;
                    case "AL" :	state = "Alagoas";				break;
                    case "AM" :	state = "Amazonas";				break;
                    case "AP" :	state = "Amapá";				break;
                    case "BA" :	state = "Bahia";				break;
                    case "CE" :	state = "Ceará";				break;
                    case "DF" :	state = "Distrito Federal";		break;
                    case "ES" :	state = "Espírito Santo";		break;
                    case "GO" :	state = "Goiás";				break;
                    case "MA" :	state = "Maranhão";				break;
                    case "MG" :	state = "Minas Gerais";			break;
                    case "MS" :	state = "Mato Grosso do Sul";	break;
                    case "MT" :	state = "Mato Grosso";			break;
                    case "PA" :	state = "Pará";					break;
                    case "PB" :	state = "Paraíba";				break;
                    case "PE" :	state = "Pernambuco";			break;
                    case "PI" :	state = "Piauí";				break;
                    case "PR" :	state = "Paraná";				break;
                    case "RJ" :	state = "Rio de Janeiro";		break;
                    case "RN" :	state = "Rio Grande do Norte";	break;
                    case "RO" :	state = "Rondônia";				break;
                    case "RR" :	state = "Roraima";				break;
                    case "RS" :	state = "Rio Grande do Sul";	break;
                    case "SC" :	state = "Santa Catarina";		break;
                    case "SE" :	state = "Sergipe";				break;
                    case "SP" :	state = "São Paulo";			break;
                    case "TO" :	state = "Tocantíns";			break;
                }
                $('[name="address[province]"] option[value="' + state + '"]').prop('selected', true);
                $('.get-rates').trigger('click');
            } else {
                alert("CEP não encontrado");
                if (aoFalhar) aoFalhar();
            }
            $(".get-rates-custom").removeClass("loading");
            $(".get-rates-custom").attr('value', 'Calcular');

        }).fail(function () {
            alert("Consulta de CEP indisponivel no momento");
            $(".get-rates-custom").removeClass("loading");
            $(".get-rates-custom").attr('value', 'Calcular');
            if (aoFalhar) aoFalhar();
        });
    };

    $(document).on('keypress', '#address_zip', function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            $(".get-rates-custom").trigger("click");
        }
    });

    $(document).on('click', '.get-rates-custom', function () {
        var campo = $("#variantid");
        var cep = $('#address_zip').val();

        // Sem variante na página, ou CEP incompleto: não mexe no carrinho.
        if (!campo[0] || String(cep).length != 9) {
            carregaFrete(cep);
            return;
        }

        var variantvalue = campo.val();

        // A gaveta fica segurada durante todo o cálculo, com carrinho vazio ou cheio:
        // o app do carrinho abre a gaveta sozinho ao ver qualquer mexida.
        segurarGaveta(true);

        jQuery.getJSON('/cart.js', function (cart) {
            // Carrinho com itens: a Shopify já tem sobre o que calcular,
            // então não encostamos no carrinho do cliente.
            if (cart.item_count > 0) {
                var soltar = aoTerminarCalculo(function () {
                    setTimeout(function () { segurarGaveta(false); }, 1200);
                });
                carregaFrete(cep, soltar);
                return;
            }

            // Carrinho vazio: põe o item por um instante para haver o que calcular.
            Shopify.addItem(variantvalue, 1, function () {
                var terminar = aoTerminarCalculo(function () {
                    desfazerItemDoCalculo(variantvalue, function () {
                        // Solta a gaveta só depois que o carrinho voltou ao normal,
                        // senão o app reage à remoção e abre a gaveta.
                        setTimeout(function () { segurarGaveta(false); }, 1200);
                    });
                });
                carregaFrete(cep, terminar);
            });
        }).fail(function () {
            segurarGaveta(false);
            carregaFrete(cep);
        });
    });
});
